import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 'bold',
      fontSize: '2rem',
      color: theme.oysterTheme.pine,
      paddingTop: '20px',
    },
    mainContainer: {
      padding: '15px 3.5vw 50px 3.5vw',
      display: 'flex',
      flexDirection: 'column',
      background: '#F6F6F6',
      minHeight: 'calc(100vh - 325px)',
    },
    modalConfirmationTitle: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: `${700} !important`,
    },
    modalConfirmationMessage: {
      fontSize: `16px !important`,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: `${500} !important`,
      color: '#677685',
    },
    cancelButton: {
      backgroundColor: '#EFF2F8',
      color: '#011B34',
      borderRadius: '8px',
      boxShadow: 'none',
      border: '2px solid #EFF2F8',
      fontWeight: 'bold',
      '&:hover': {
        color: theme.oysterTheme.cotton,
        backgroundColor: `${theme.oysterTheme.dolphin} !important`,
        border: `2px solid ${theme.oysterTheme.dolphin}`,
        boxShadow: 'none',
        cursor: 'pointer',
      },
    },
    confirmButton: {
      marginLeft: 2,
      backgroundColor: theme.oysterTheme.pine,
      color: theme.oysterTheme.cotton,
      borderRadius: '8px',
      boxShadow: '0px 8px 24px rgba(1, 70, 81, 0.16)',
      border: '2px solid #014651',
      fontWeight: 'bold',
      '&:hover': {
        color: theme.oysterTheme.cotton,
        backgroundColor: '#5C838A !important',
        border: '2px solid #5C838A',
        boxShadow: 'none',
        cursor: 'pointer',
      },
    },
    confirmCancelButton: {
      marginLeft: 2,
      backgroundColor: theme.oysterTheme.ferrari,
      color: theme.oysterTheme.cotton,
      borderRadius: '8px',
      boxShadow: '0px 8px 24px rgba(1, 70, 81, 0.16)',
      border: `2px solid ${theme.oysterTheme.ferrari}`,
      fontWeight: 'bold',
      '&:hover': {
        color: theme.oysterTheme.cotton,
        backgroundColor: '#EA6766 !important',
        border: '2px solid #EA6766',
        boxShadow: 'none',
        cursor: 'pointer',
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    card: {
      display: 'flex',
      background: '#FFFFFF',
      borderRadius: '10px',
      flexDirection: 'column',
      marginTop: '22px ',
      [theme.breakpoints.down('xs')]: {
        maxWidth: '90vw',
      },
    },
    containerButtons: {
      padding: '30px',
    },
    subTotalsGroupsContainer: {
      paddingLeft: '30px',
      paddingRight: '30px',
    },
    buttonPrimary: {
      background: '#014651',
      width: '254px',
      height: '47px',
      color: '#FFFFFF',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '8px',
    },
    buttonSecondary: {},
    columnItemSuccess: {
      color: '#1FD7AE',
      fontWeight: 400,
      fontSize: '14px',
      marginLeft: '7px',
    },
    columnItemError: {
      color: '#EA6766',
      fontWeight: 400,
      fontSize: '14px',
      marginLeft: '7px',
    },
    columnItemNameError: {
      color: '#EA6766',
      fontWeight: 400,
      fontSize: '12px',
    },
    columnCurrencySuccess: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 700,
      fontSize: '16px',
      color: '#011B34',
    },
    columnCurrencyError: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 700,
      fontSize: '16px',
      color: '#8F9499',
      textDecoration: 'line-through',
    },
    columnNumberText: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 400,
      fontSize: '14px',
      color: '#8F9499',
    },
    columnName: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 500,
      fontSize: '16px',
      color: '#011B34',
    },
    containerButtonAmount: {
      display: 'flex',
      width: '100%',
      maxWidth: '544px',
      justifyContent: 'space-around',
    },
    containerAmount: {
      display: 'flex',
      background: theme.oysterTheme.pearl,
      padding: '16px',
      borderRadius: '6px',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 600,
      fontSize: '18px',
      color: theme.oysterTheme.pine,
    },
    containerSubTotals: {
      display: 'flex',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '16px',
      paddingBottom: '5px',
      borderRadius: '6px',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 400,
      fontSize: '18px',
      color: theme.oysterTheme.pine,
    },
    subTotals: {
      textAlign: 'right',
      fontWeight: 700,
      color: '#B0B6C2',
    },
    totalAmountContainer: {
      textAlign: 'right',
    },
    totalAmountCurrency: {
      fontSize: '14px',
    },
    middleContainer: {
      marginTop: 20,
    },
    refundAmountMessageContainer: {
      marginTop: 20,
      background: 'rgba(24, 144, 255, .10)',
      padding: '12px 16px 12px 16px',
      borderRadius: '8px',
    },
    refundAmountMessageInfo: {
      color: '#011B34',
      fontWeight: 500,
      fontSize: '16px',
    },
    blueBold: {
      fontWeight: 700,
      color: '#1890FF',
    },
    canceledCard: {
      display: 'flex',
      background: '#FFFFFF',
      borderRadius: '10px',
      flexDirection: 'column',
      marginTop: '39px',
    },
    canceledContainerSubtitle: {
      padding: '35px',
      display: 'flex',
      flexDirection: 'column',
      whiteSpace: 'break-spaces',
    },
    canceledTitleStep: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 700,
      fontSize: '26px',
      color: theme.oysterTheme.ferrari,
    },
    canceledSubtitleStep: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 500,
      fontSize: '1rem',
      color: '#707070',
      marginTop: '13px',
    },
    rowsCounter: {
      background: 'rgba(24, 144, 255, 0.10)',
      color: '#1890FF',
      fontSize: '0.9rem',
      fontWeight: 500,
      borderRadius: 12,
      padding: '2px 8px 2px 8px',
    },
  }),
);

export default useStyles;
